import send from "../../util/request";

export function addProviderApi(params) {
  return send({ url: '/ipp/relation/create', method: 'POST', data: params });
}

export function companyTree(params) {
  return send({ url: '/ipp/relation/company', method: 'POST', data: params });
}

export function relationList(params) {
  return send({ url: '/ipp/relation/select', method: 'POST', data: params, options: { loading: true } });
}

export function updateRelation(params) {
  return send({ url: '/ipp/relation/update', method: 'POST', data: params });
}

export function deleteRelation(params) {
  return send({ url: '/ipp/relation/delete', method: 'POST', data: params });
}